import { Injectable, signal } from '@angular/core';
import { ClientModel } from '../../core/models/client.model';
import { CountriesModel } from '../../core/models/countries.model';
import { TypeDocumentModel } from '../../core/models/type-document.model';

@Injectable({
  providedIn: 'root'
})
export class ClientStoreService {

  private _clients = signal<ClientModel[]>([]);
  readonly clients = this._clients.asReadonly();

  private _clientsFiltered = signal<ClientModel[]>([]);
  readonly clientsFiltered = this._clientsFiltered.asReadonly();

  private _countries = signal<CountriesModel[]>([]);
  readonly countries = this._countries.asReadonly();

  private _typeDocument = signal<TypeDocumentModel[]>([]);
  readonly typeDocument = this._typeDocument.asReadonly();

  private _searchValue = signal<string>('');
  readonly searchValue = this._searchValue.asReadonly();

  setClients(clients: ClientModel[]) {
    this._clients.set(clients);
  }

  addClient(client: ClientModel) {
    this._clients.update(current => [...current, client]);
  }

  deleteClient(id: ClientModel["id"]) {
    this._clients.update(current => current.filter(c => c.id !== id));
  }

  updateClient(id: ClientModel["id"], updatedClient: ClientModel) {
    this._clients.update(current => {
      const index = current.findIndex(c => c.id === id);
      if (index !== -1) {
        current[index] = updatedClient;
      }
      return current;
    });
  }

  setClientsFiltered(clients: ClientModel[]) {
    this._clientsFiltered.set(clients);
  }

  setSearchValue(value: string) {
    this._searchValue.set(value);
  }

  filterClients(searchValue: string) {
    this._searchValue.set(searchValue);
    const clientsFiltered = this._clients().filter(client =>
      client.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      (client.alias ?? client.slug ?? '').toLowerCase().includes(searchValue.toLowerCase())
    );
    this.setClientsFiltered(clientsFiltered);
  }

  setCountries(countries: CountriesModel[]) {
    this._countries.set(countries);
  }
    
  setTypeDocument(typeDocument:TypeDocumentModel[]){
    this._typeDocument.set(typeDocument)
  }

}
